import { render, staticRenderFns } from "./excellenttemplate.vue?vue&type=template&id=e44005a0"
import script from "./excellenttemplate.vue?vue&type=script&lang=js"
export * from "./excellenttemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports